export default __webpack_public_path__ + "static/media/comic2_Panel1.fe9be65e.png";